import React from 'react';
import Icon from '../../../components/AppIcon';

const ErrorDashboardCard = ({ title, value, icon, color, trend }) => {
  const getColorClasses = (color) => {
    const colors = {
      red: 'bg-red-50 text-red-600',
      green: 'bg-green-50 text-green-600',
      orange: 'bg-orange-50 text-orange-600',
      blue: 'bg-blue-50 text-blue-600',
      purple: 'bg-purple-50 text-purple-600'
    };
    return colors?.[color] || 'bg-gray-50 text-gray-600';
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-neutral-200 p-5">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-neutral-600 mb-1">{title}</p>
          <p className="text-3xl font-bold text-neutral-900 mb-2">{value}</p>
          <p className="text-xs text-neutral-500">{trend}</p>
        </div>
        <div className={`p-3 rounded-lg ${getColorClasses(color)}`}>
          <Icon name={icon} size={24} />
        </div>
      </div>
    </div>
  );
};

export default ErrorDashboardCard;
